export default "__VITE_ASSET__Bn1Q0JVA__"